import { render } from "./LowStockReport.vue?vue&type=template&id=541bdef2&scoped=true"
import script from "./LowStockReport.vue?vue&type=script&lang=js"
export * from "./LowStockReport.vue?vue&type=script&lang=js"

import "./LowStockReport.vue?vue&type=style&index=0&id=541bdef2&scoped=true&lang=css"

import exportComponent from "D:\\DockerProjects\\armt_pos_v2_docker\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-541bdef2"]])

export default __exports__